'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');

var Keyboard = React.createClass({
  render: function () {
    return (
      <div
        className="component-Keyboard">
        <img width='100%' height='100%' src={assetsHelper.getComponentAsset(this.getKeyboard())}/>
      </div>
    );
  },
  getKeyboard: function () {
    var keyboards = {
      ktGridNine_SmHori: 'iphoneKeyboard_landscape_number',
      ktLetter_SmHori: 'iphoneKeyboard_landscape_letter',
      ktGridNine_SmVert: 'iphoneKeyboard_portrait_number',
      ktLetter_SmVert: 'iphoneKeyboard_portrait_letter',
      ktNumber_SmHori: 'iphoneKeyboard_landscape_symbol',
      ktNumber_SmVert: 'iphoneKeyboard_portrait_symbol'
    };
    return keyboards[this.props.keyboardType + '_' + this.props.direction];
  }
});

module.exports = Keyboard;



// WEBPACK FOOTER //
// ./src/views/Components/Keyboard.jsx